import { Link } from 'react-router-dom'

export function LocationLink({
  uid,
  children,
  className,
}: {
  uid: string | null | undefined
  children?: React.ReactNode
  className?: string
}) {
  if (!uid) return <>{children ?? uid}</>
  return (
    <Link
      to={`/locations/${uid}`}
      className={
        className ??
        'text-ostrel-ink hover:text-ostrel-accent focus:outline-none focus:ring-1 focus:ring-ostrel-gold'
      }
    >
      {children ?? uid}
    </Link>
  )
}
